import React from 'react';
export function Button({
  children,
  onClick,
  variant = 'primary',
  icon,
  className = '',
  fullWidth = false,
  disabled = false
}) {
  const baseClasses = 'flex items-center justify-center rounded-lg px-4 py-3 font-medium transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100';
  const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800',
    secondary: 'bg-gray-100 text-gray-800 hover:bg-gray-200 active:bg-gray-300',
    outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50 active:bg-gray-100',
    danger: 'bg-red-600 text-white hover:bg-red-700 active:bg-red-800'
  };
  return <button onClick={onClick} disabled={disabled} className={`${baseClasses} ${variantClasses[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-27">
      {icon && <span className="mr-2" data-id="element-28">{icon}</span>}
      {children}
    </button>;
}